import { DialogsProvider } from '@toolpad/core';

type Props = {
  children: React.ReactElement;
};

export default function CommandsIndex({ children }: Props) {
  return <DialogsProvider>{children}</DialogsProvider>;
}
